/**
 * Helpers de formatage alignés sur la présentation v2.2 (FCFA, dates fr-FR).
 */
const NF = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });

/** Nombre entier avec séparateurs de milliers (espace insécable fin). */
export function fmtNumber(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '0';
  return NF.format(Math.round(n));
}

/** Montant en FCFA : « 1 234 567 FCFA ». */
export function fmtFCFA(n: number | null | undefined): string {
  return `${fmtNumber(n)} FCFA`;
}

/** Date ISO -> « jj/mm/aaaa ». */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString('fr-FR');
}

/** Ancienneté depuis une date d'embauche : « 3 ans 2 mois ». */
export function fmtAnciennete(dateEmbauche: string | null | undefined, now = new Date()): string {
  if (!dateEmbauche) return '—';
  const debut = new Date(dateEmbauche);
  if (Number.isNaN(debut.getTime())) return '—';
  const mois = Math.max(
    0,
    (now.getFullYear() - debut.getFullYear()) * 12 + (now.getMonth() - debut.getMonth()),
  );
  const ans = Math.floor(mois / 12);
  const resteMois = mois % 12;
  if (ans === 0) return `${resteMois} mois`;
  const libelleAns = `${ans} an${ans > 1 ? 's' : ''}`;
  return resteMois === 0 ? libelleAns : `${libelleAns} ${resteMois} mois`;
}

/** Période « aaaa-mm » -> « mois aaaa » (ex. « juin 2026 »). */
export function fmtPeriode(periode: string | null | undefined): string {
  if (!periode) return '—';
  const [y, m] = periode.split('-');
  const mois = [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
  ];
  const idx = Number(m) - 1;
  if (idx < 0 || idx > 11) return periode;
  return `${mois[idx]} ${y}`;
}

/** Échappe le HTML pour toute donnée injectée dans un template. */
export function esc(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
